const rootUrl = process.env.REACT_APP_API

export function queryPopulation() {
  const url = `${rootUrl}/callmodel`
  const params = {
    results_param: 'accessResults',
    model: 'waTomorrow',
    req_params: {
      format: 'json',
    }
  }

  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(params),
  })
}

export function queryStructurePlans() {
  const url = `${rootUrl}/retrieveStructurePlans`
  const params = {}

  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(params),
  })
}
